export default __webpack_public_path__ + "static/spa-fcf0ffe63320ddb78119b8212e8d5833.jpg";